import * as React from "react";
import { Grid, Button } from "components/controls/widget";
import { useApplicationList, ContentPage } from "./store";
import PageTitle from "common/admin/PageTitle";
import PageContainer from "common/admin/PageContainer";
import PageContent from "common/admin/PageContent";
import { Application } from "../view";

const View = () => {
    const [{ clubID, selectedApplicationId }, actions] = useApplicationList();

    return <PageContainer>
        <PageTitle title="Přihláška člena" />
        <PageContent>
            <Grid container direction="column" spacing={24}>
                <Grid item>
                    <Button variant="outlined" onClick={() => actions.goToPage(ContentPage.List)}>{'Zpět na seznam přihlášek členů'}</Button>
                </Grid>
                <Grid item>
                    <Application clubId={clubID} applicationId={selectedApplicationId} />
                </Grid>
            </Grid>
        </PageContent>
    </PageContainer>;
}

export {
    View as EditView
}